import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const zh: Translations = {
  common: {
    appName: appName,
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    search: '搜索',
    noResults: '没有找到结果',
    error: '发生错误',
    success: '成功',
  },
  header: {
    searchPlaceholder: '搜索 Coser、美女、旗袍、模特...',
    searchPlaceholderMobile: '搜索...',
    home: '首页',
    hotgirl: '美女',
    coser: 'Coser',
    model: '模特',
    upload: '上传',
    notifications: '通知',
    login: '登录',
    register: '注册',
  },
  footer: {
    tagline: `最佳 Coser、美女、模特照片分享平台。${appName} 的`,
    copyright: `© {year} ${appName}. 保留所有权利。`,
    sections: { explore: '探索', account: '账户', support: '支持' },
    links: {
      home: '首页', hotgirl: '美女', coser: 'Coser', model: '模特', aoDai: '越南旗袍',
      login: '登录', register: '注册', upload: '上传照片', dashboard: '控制台',
      terms: '服务条款', privacy: '隐私政策', report: '举报违规', contact: '联系我们',
    },
  },
  collections: {
    title: '收藏夹',
    createAlbum: '创建相册',
    saved: '已收藏',
    noSaved: '还没有收藏的照片',
    noSavedHint: '立即探索照片 →',
    removedSave: '已取消收藏',
    createModalTitle: '创建新相册',
    albumNamePlaceholder: '相册名称...',
    cancel: '取消',
    create: '创建',
    albumCreated: '相册已创建',
  },
  home: {
    title: '探索',
    titleHighlight: '美丽',
    titleSuffix: '生活',
    subtitle: '每天更新数千张 Coser、美女、模特照片',
    sortNewest: '最新',
    sortTrending: '趋势',
    sortPopular: '热门',
    allCategories: '全部',
    noMorePosts: '你已经看完所有照片了',
  },
  auth: {
    login: {
      title: '登录以继续',
      continueWithGoogle: '使用 Google 继续',
      orLoginWithEmail: '或使用邮箱登录',
      email: '邮箱',
      password: '密码',
      forgotPassword: '忘记密码？',
      submitButton: '登录',
      loading: '登录中...',
      noAccount: '还没有账户？',
      registerLink: '立即注册',
      errorCredentials: '邮箱或密码错误',
      successLogin: '登录成功！',
    },
    register: {
      title: '创建免费账户',
      displayName: '显示名称',
      displayNamePlaceholder: '张三',
      email: '邮箱',
      password: '密码',
      passwordPlaceholder: '至少 8 个字符',
      confirmPassword: '确认密码',
      submitButton: '注册',
      loading: '创建账户中...',
      hasAccount: '已有账户？',
      loginLink: '立即登录',
      errorPasswordMismatch: '密码不匹配',
      errorPasswordLength: '密码至少 8 个字符',
      errorGeneric: '注册失败',
      successRegister: '注册成功！',
      emailTaken: '邮箱已被使用',
      serverError: '服务器错误，请稍后再试',
    },
    forgotPassword: {
      title: '忘记密码',
      subtitle: '输入您的邮箱，我们将发送重置链接',
      email: '邮箱',
      submitButton: '发送重置链接',
      backToLogin: '返回登录',
      sending: '正在发送...',
      emailSent: '已发送电子邮件！',
      checkEmail: '请检查 {email} 的收件箱以获取重置密码链接。',
      instructions: '输入您的电子邮件，我们将发送重置密码链接。',
    },
  },
  userMenu: {
    dashboard: '控制台',
    collections: '收藏夹',
    settings: '设置',
    logout: '退出登录',
  },
  settings: {
    title: '账户设置',
    profile: {
      nav: '个人资料',
      title: '个人信息',
      displayName: '显示名称',
      username: '用户名',
      website: '网站',
      bio: '简介',
      bioPlaceholder: '介绍一下自己...',
      changeAvatar: '更换头像',
      avatarHint: 'JPG、PNG、WebP 最大 5MB',
      saveButton: '保存更改',
      saving: '保存中...',
      savedSuccess: '更改已保存',
    },
    password: { 
      nav: '密码',
      title: '更改密码',
      fields: {
        currentPassword: '当前密码',
        newPassword: '新密码',
        confirm: '确认新密码',
      },
      errors: {
        confirm: '新密码不匹配',
        minLength: '密码至少 8 个字符',
      },
      success: '已更改密码',
      saving: '正在保存...',
      submit: '更改密码',
    },
    notifications: { 
      nav: '通知',
      title: '通知设置',
      options: {
        likes: '当有人喜欢你的照片时',
        comments: '当有人评论时',
        replies: '当有人回复你的评论时',
        follows: '当有人关注你时',
        approved: '当帖子被审核时',
        email_digest: '每周邮件摘要',
        marketing: '促销和活动通知',
      },
      saveSuccess: '已保存通知设置',
      saving: '正在保存...',
      saveButton: '保存设置',
    },
    security: { 
      nav: '安全',
      twoFactorAuth: '两步验证 (2FA)',
      twoFactorAuthHint: '通过应用程序的验证码增强安全性',
      comingSoon: '即将推出',
      activeSessions: '活动会话',
      currentBrowser: '当前浏览器',
      lastLogin: '上次登录',
      active: '活跃',
      dangerZone: '危险区域',
      deleteAccountHint: '删除帐户将永久删除您的所有数据。',
      deleteAccount: '删除帐户',
    },
  },
  post: {
    likes: '{count} 个赞',
    views: '{count} 次查看',
    shares: '{count} 次分享',
    comments: '{count} 条评论',
    save: '收藏',
    saved: '已收藏',
    share: '分享',
    linkCopied: '链接已复制！',
    follow: '关注',
    following: '已关注',
    relatedPosts: '相关帖子',
    commentPlaceholder: '写评论...',
    commentLoginPlaceholder: '登录以评论...',
    commentSubmit: '发布',
    commentSubmitting: '发布中...',
    noComments: '还没有评论，来第一个吧！',
    savedToCollection: '已添加到收藏夹',
    removedFromCollection: '已取消收藏',
    description: '描述',
    profileView: '查看个人资料',
  },
  notifications: {
    title: '通知',
    empty: '没有通知',
    markAllRead: '全部标为已读',
    types: {
      like_post: '已喜欢您的照片',
      comment: '已评论您的照片',
      reply: '已回复您的评论',
      follow: '已关注您',
      approve: '您的帖子已被批准',
      reject: '您的帖子已被拒绝',
      system: '系统通知',
    },
  },
  search: {
    title: '搜索结果：',
    result: '结果',
    tryOtherKeywords: '尝试其他关键词吧',
    noResults: '没有找到相关结果：',
    placeholder: '搜索...',
    thisHashtag: '与此标签相关的照片',
  },
  upload: {
    title: '上传照片',
    dragDrop: '拖放或点击选择',
    supportedFormats: '支持 JPG、PNG、WebP、GIF',
    submit: '发布',
    submitting: '发布中...',
    titleField: '标题',
    titlePlaceholder: '输入吸引人的标题...',
    descriptionField: '描述',
    descriptionPlaceholder: '关于照片集的详细描述...',
    hashtagsField: '标签',
    statusField: '状态',
    statusPublic: '公开',
    statusPrivate: '私密',
    statusDraft: '草稿',
    error: '上传时出错',
    errorSelect: '至少选择 1 张照片',
    errorTitle: '请输入标题',
    photos: '照片',
    uploading: '正在上传...',
  },
  notFound: {
    title: '页面未找到',
    subtitle: '您访问的页面不存在。',
    backHome: '返回首页',
  },
  liked: {
    title: '已喜欢的帖子',
    empty: '还没有喜欢的帖子',
  },
  user: {
    unknown: '匿名',
  },
  globalError: {
    title: '发生错误',
    subtitle: '对不起给您带来的不便。请再试一次。',
    retry: '重试',
  },
  username: {
    posts: '帖子',
    likes: '喜欢',
    followers: '粉丝',
    following: '关注中',
    editProfile: '编辑个人资料',
    message: '发消息',
    noPosts: '还没有帖子',
    bio: '查看 {name} 的照片',
    notFound: '用户不存在',
  },
  topic: {
    notFound: '主题不存在',
    viewTitle: '查看主题的照片 ',
  },
  dashboard: {
    title: '仪表板',
    welcome: '欢迎',
    stats: {
      posts: '帖子',
      views: '查看',
      likes: '喜欢',
      comments: '评论',
    },
  },
  adsblock: {
    title: "您正在使用广告拦截器",
    description: "请关闭广告拦截器以查看高质量图片，并帮助我们保持网站免费运行。",
    action: "我已关闭 — 重新加载",
    cancel: "跳过"
  },
  pwa: {
    title: `安装 ${appName} 以获得更好的体验！`,
    iosSubtitle: `按“分享”→“添加到主屏幕”`,
    androidSubtitle: `获取新照片集发布的通知`,
    installButton: `安装 ${appName}`,
    disclaimer: `快速安装，无需应用商店。`,
  },
  autotrans: {
    title: '自动翻译',
    translated: '翻译',
    origin: '原始内容',
  },
  subscription: {
    title: '订阅通知',
    description: '新照片集发布时立即获取通知。',
    subscribeButton: '订阅',
    unsubscribeButton: '取消订阅',
    subscribed: '您已订阅通知。',
    unsubscribed: '您已取消订阅通知。',
    error: '更新订阅时发生错误。请再试一次。',
    success_tit: '🎉 通知已启用！',
    denied_tit: '通知被拒绝',
    error_tit: '发生错误',
    success_des: '您将收到新内容可用时的通知。',
    denied_des: '您可以在浏览器设置中重新启用它们。',
    error_des: '请稍后再试。',
    skip: '跳过',
    processing: '处理中...',
    noti: '启用通知',
    rule: '仅显示新内容的通知。',
    notify_title: `通知 - ${appName}`,
    notify_body: "新画廊已发布。现在就去看看吧！",
  },
  contact: {
    title: '联系我们',
    subtitle: '我们很乐意听到您的声音！请填写以下表格，我们会尽快与您联系。',
    name: '姓名',
    email: '电子邮件',
    subject: '主题',
    message: '消息',
    submitButton: '发送消息',
    sending: '发送中...',
    successTitle: '消息已发送！',
    successMessage: '感谢您的联系。我们会尽快与您联系。',
    errorTitle: '发生错误',
    errorMessage: '发送消息时发生错误。请稍后再试。',
    res_time_title: '响应时间',
    res_time: '我们通常在 1-3 个工作日内回复。',
    report_content: '报告内容',
    report_content_hint: '要报告帖子或用户，请直接在内容上使用报告按钮或选择上面的“报告内容”。',
    value_default: '选择一个主题',
    value_general: '一般查询',
    value_report: '报告内容',
    value_account: '帐户问题',
    value_business: '业务/合作',
    value_feedback: '反馈与建议',
    value_other: '其他'
  },
  language: {
    label: `语言`,
    en: `English`, vi: `Tiếng Việt`, zh: `中文`, ja: `日本語`,
    ko: `한국어`, ar: `العربية`, fr: `Français`, es: `Español`,
    ru: `Русский`,
    hi: `हिन्दी`,
    id: `Indonesia`,
    de: `Deutsch`,
    pt: `Português`,
    it: `Italiano`,
  },
};

export default zh;
